var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userCenterTitle"},[_c('p',{staticClass:"infoItem-title"},[_c('span',{staticClass:"infoItem-icon"}),_c('span',{staticClass:"infoItem-text"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }